webpackJsonp([21733507128203],{

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = exports.NewsPostTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Content = __webpack_require__(17);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsPostTemplate = exports.NewsPostTemplate = function NewsPostTemplate(_ref) {
	  var content = _ref.content,
	      contentComponent = _ref.contentComponent,
	      description = _ref.description,
	      title = _ref.title;
	
	  var PostContent = contentComponent || _Content2.default;
	
	  return _react2.default.createElement(
	    "section",
	    { className: "section" },
	    _react2.default.createElement(
	      "div",
	      { className: "container content" },
	      _react2.default.createElement(
	        "div",
	        { className: "columns" },
	        _react2.default.createElement(
	          "div",
	          { className: "column is-10 is-offset-1" },
	          _react2.default.createElement(
	            "h1",
	            { className: "title is-size-2 has-text-weight-bold is-bold-light" },
	            title
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            description
	          ),
	          _react2.default.createElement(PostContent, { content: content })
	        )
	      )
	    )
	  );
	};
	
	exports.default = function (props) {
	  var post = props.data.markdownRemark;
	
	
	  return _react2.default.createElement(NewsPostTemplate, {
	    content: post.html,
	    contentComponent: _Content.HTMLContent,
	    description: post.frontmatter.description,
	    title: post.frontmatter.title
	  });
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-news-post-js-b85e1ed0e9e778475202.js